<template>
  <button
    class="design-button"
    :class="{
      fullWidth,
      primary: color === 'primary',
      green: color === 'green',
      'x-small': size === 'x-small',
      'x-large': size === 'x-large',
      dimmed: disabled
    }"
    @click="$emit('click')"
    :disabled="disabled"
  >
    <div class="design-button-content">{{ text }}</div>
  </button>
</template>
<script>
export default {
  name: 'DesignButton',
  props: {
    text: {
      type: String,
      required: true
    },
    fullWidth: {
      type: Boolean,
      required: false
    },
    color: {
      type: String,
      required: false,
      default: ''
    },
    size: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false
    }
  }
};
</script>
<style lang="scss" scoped>
.design-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 10px 10px;
  height: 35px;
  font-size: 14px;
  line-height: 20px;
  background-color: #fff;
  border: 1px solid #a8aaae;
  border-radius: 6px;
  width: fit-content;
  .design-button-content {
    color: #7e8082;
    display: flex;
    justify-content: center;
    font-size: 14px;
    line-height: 20px;
    flex: 1;
    font-weight: 500;
    text-align: center;
  }

  &.x-small {
    font-size: 12px;
    line-height: 17px;
    padding: 4px 14px;
    height: 25px;
    border-radius: 4px;

    .design-button-content {
      font-size: 12px;
      line-height: 17px;
    }
  }
  &.x-large {
    font-size: 12px;
    line-height: 17px;
    margin: 0px 20px 20px 20px;
    padding: 10px 20px;
    height: 35px;
    width: 370px;
    border-radius: 4px;

    .design-button-content {
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
      color: #7e8082;
    }
  }
  &:hover,
  &:active {
    background-color: #f8f8f9;
  }

  &.primary {
    background-color: #5578f0;
    border: 1px solid transparent;
    &:hover,
    &:active {
      background-color: #4d6cd8;
    }
    .design-button-content {
      color: #ffffff;
    }
  }
  &.green {
    background-color: #ddf6e8 !important;
    border: 1px solid transparent !important;
    &:hover,
    &:active {
      background-color: #cbf2dc !important;
    }
    .design-button-content {
      color: #28c76f;
    }
  }
  &.fullWidth {
    width: 100%;
  }
  &.dimmed {
    opacity: 0.5;
  }
}
</style>
